import { Component } from '@angular/core';
import { AbstractControl, FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { passwordValidator, PASSWORD_REQUIREMENTS_HINT } from '../../shared/validators/password.validator';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { AuthService } from 'src/app/services/auth.service';
import { UserService } from 'src/app/services/user.service';

@Component({
  selector: 'rap-change-password-modal',
  templateUrl: './change-password-modal.component.html',
  styleUrls: ['./change-password-modal.component.scss']
})
export class ChangePasswordModalComponent {
  readonly requirementsHint = PASSWORD_REQUIREMENTS_HINT;
  pwdResetCodeSent: boolean = true;
  pwdUpdateSubmitted: boolean = false;
  confirmPwdUpdateSubmitted: boolean = false;
  passwordHelpForm: FormGroup;
  error: String;
  fieldTextType: boolean;
  fieldTextType1: boolean;
  isLoading: boolean = false;

  toggleFieldTextType() {
    this.fieldTextType = !this.fieldTextType;
  }

  toggleFieldTextType1() {
    this.fieldTextType1 = !this.fieldTextType1;
  }
  constructor(public activeModal: NgbActiveModal, private fb: FormBuilder, private authService: AuthService, private userService: UserService) {
    this.passwordHelpForm = this.fb.group({
      email: new FormControl(this.authService.getUserEmail(), [Validators.required, Validators.email]),
      currentPassword: new FormControl(null, [Validators.required]),
      // Was minLength(8) only, which is LOOSER than Cognito: a lowercase-only
      // password passed here and was then rejected server-side. Same policy
      // module as signup and password-reset so all three agree with the pool.
      password: new FormControl(null, [Validators.required, passwordValidator()]),
      confirmPassword: new FormControl(null, [Validators.required]),
    }, { validators: this.passwordMatchValidator });
  }


  // ngOnInit used to call setValidators(Validators.required) on password and
  // confirmPassword. setValidators REPLACES the validator list, so it silently
  // discarded whatever the constructor had configured - which is why this form
  // enforced no strength policy at all and accepted a one-character password
  // that Cognito then rejected. The constructor already sets the correct
  // validators, so the override is removed rather than made additive.

  get currentPassword() {
    return this.passwordHelpForm.get('currentPassword');
  }

  get password() {
    return this.passwordHelpForm.get('password');
  }

  get confirmPassword() {
    return this.passwordHelpForm.get('confirmPassword');
  }

  passwordMatchValidator(formGroup: FormGroup) {
    const newPassword = formGroup.get('password');
    const confirmPassword = formGroup.get('confirmPassword');

    if (newPassword && confirmPassword && newPassword.value !== confirmPassword.value) {
      confirmPassword.setErrors({ mismatch: true });
    } else if (confirmPassword && confirmPassword.errors && confirmPassword.errors['mismatch']) {
      // Only clear the mismatch error, keep other validation errors
      delete confirmPassword.errors['mismatch'];
      if (Object.keys(confirmPassword.errors).length === 0) {
        confirmPassword.setErrors(null);
      }
    }
  }

  get f(): { [key: string]: AbstractControl } {
    return this.passwordHelpForm.controls;
  }

  onSubmit() {
    if (this.passwordHelpForm.valid) {
      this.isLoading = true;
      this.error = null; // Clear any previous errors

      // confirmPassword is a frontend-only match check (see passwordMatchValidator) and is not sent.
      const payload = {
        currentPassword: this.passwordHelpForm.get('currentPassword')?.value,
        newPassword: this.passwordHelpForm.get('password')?.value,
      };

      console.log('Form is valid');

      this.userService.updatePassword(payload).subscribe({
        next: (result) => {
          console.log(result)
          this.isLoading = false;
          this.activeModal.close(true);
        },
        error: (error) => {
          console.error('Password update failed:', error);
          this.isLoading = false;
          this.error = 'Failed to update password. Please try again.';
          if (error.error && error.error.message) {
            this.error = error.error.message;
          } else if (error.status === 400) {
            this.error = 'Current password is incorrect, or new password requirements not met.';
          } else if (error.status === 500) {
            this.error = 'Server error. Please try again later.';
          }
        }
      });
    } else {
      console.log('Form is not valid');
      // Mark all fields as touched to show validation errors
      Object.keys(this.passwordHelpForm.controls).forEach(key => {
        this.passwordHelpForm.get(key)?.markAsTouched();
      });
    }
  }
}
